const STORAGE_KEY = 'billing.actionsNeeded.dismissedAt';
const THREE_DAYS_MS = 3 * 24 * 60 * 60 * 1000;

/** True when the user dismissed the strip and the 3-day window has not elapsed. */
export function isActionsNeededDismissed(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }
  const raw = localStorage.getItem(STORAGE_KEY);
  if (raw == null || raw === '') {
    return false;
  }
  const dismissedAt = Number(raw);
  if (Number.isNaN(dismissedAt)) {
    return false;
  }
  return Date.now() - dismissedAt < THREE_DAYS_MS;
}

export function dismissActionsNeededStrip(): void {
  if (typeof window === 'undefined') {
    return;
  }
  localStorage.setItem(STORAGE_KEY, String(Date.now()));
}
